module.exports = __webpack_public_path__ + "img/HQTS-white.5517dfeb.png";